import { useSearchParams } from 'next/navigation';
import { MapViewMode, MapViewQueryParam } from '../components/ItemsMap/types';

export const useGetIsMapView = (queryParam: MapViewQueryParam) => {
  const params = useSearchParams();
  const itemsView = params.get(queryParam);
  const isMapView = itemsView === MapViewMode.map;

  return isMapView;
};
